import React from 'react'
import { Pressable, Text, View } from 'react-native'

import { multiSelect, selectOption } from '@ui-kit/components/formComponents/MultiSelect/styles'
import { caption } from '@ui-kit/core/typography'
import { bgColor, textColor } from '@ui-kit/styles/colors'

import type { MultiSelectOptionValue, MultiSelectProps, SelectOptionProps } from './types'

const SelectOption = (props: SelectOptionProps) => {
  const { container, text } = selectOption({ isChecked: props.isSelected })

  return (
    <Pressable
      testID={props.testID}
      className={container({
        className: bgColor({ color: props.isSelected ? 'brandLime' : 'uiLight' }),
      })}
      onPress={props.onPress}
    >
      <Text className={text({ className: textColor({ color: 'uiDark' }) })}>{props.label}</Text>
    </Pressable>
  )
}

const MultiSelect = (props: MultiSelectProps) => {
  const { container } = multiSelect()

  const handleOnPressItem = async (
    changedOptionValue: MultiSelectOptionValue,
    changedOptionIndex: number
  ) => {
    const currentValue = props.value || []
    const selectedValueIndex = currentValue.indexOf(changedOptionValue)

    const newValue =
      selectedValueIndex !== -1
        ? currentValue.filter((value) => value !== changedOptionValue)
        : [...currentValue, changedOptionValue]

    await props.onValueChange?.(newValue, changedOptionIndex)
  }

  return (
    <View>
      <View className={container()}>
        {props.options.map((option, index) => {
          const isOptionSelected = props.value?.includes(option.value) ?? false
          return (
            <SelectOption
              key={String(option.value)}
              testID={`multiselect-option-${option.value}`}
              label={option.label}
              onPress={() => handleOnPressItem(option.value, index)}
              isSelected={isOptionSelected}
            />
          )
        })}
      </View>
      {props.errorMessage ? (
        <Text className={caption({ color: 'uiRed' })}>{props.errorMessage}</Text>
      ) : null}
    </View>
  )
}

export default MultiSelect
